import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';

import type { BaseAction } from '../@types/actions';
import type { FinancialInformation } from '../@types/finance';
import * as http from '../Http';
import { buildGetRequest } from '../Http/requestTemplates';
import requestCache from '../utils/request-cache';

export const RESET_DEFAULT_FINANCE_INFORMATION =
  'DEFAULT_FINANCE_INFORMATION/RESET_DEFAULT_FINANCE_INFORMATION';
type RESET_DEFAULT_FINANCE_INFORMATION_TYPE = BaseAction<typeof RESET_DEFAULT_FINANCE_INFORMATION>;

export const REQ_GET_DEFAULT_FINANCE_INFORMATION = 'REQ/GET_DEFAULT_FINANCE_INFORMATION';
export const RCV_GET_DEFAULT_FINANCE_INFORMATION = 'RCV/GET_DEFAULT_FINANCE_INFORMATION';
type REQ_GET_DEFAULT_FINANCE_INFORMATION_TYPE = BaseAction<
  typeof REQ_GET_DEFAULT_FINANCE_INFORMATION
>;
type RCV_GET_DEFAULT_FINANCE_INFORMATION_TYPE = BaseAction<
  typeof RCV_GET_DEFAULT_FINANCE_INFORMATION
> & {
  response: FinancialInformation;
};

export const REQUEST_FAILED = 'DEFAULT_FINANCE_INFORMATION/REQUEST_FAILED';
type REQUEST_FAILED_TYPE = BaseAction<typeof REQUEST_FAILED> & {
  action: typeof REQ_GET_DEFAULT_FINANCE_INFORMATION;
};

export type DEFAULT_FINANCIAL_INFORMATION_ACTION =
  | REQ_GET_DEFAULT_FINANCE_INFORMATION_TYPE
  | RCV_GET_DEFAULT_FINANCE_INFORMATION_TYPE
  | RESET_DEFAULT_FINANCE_INFORMATION_TYPE
  | REQUEST_FAILED_TYPE;

type Dispatch = ReduxDispatch<DEFAULT_FINANCIAL_INFORMATION_ACTION>;

export const getDefaultFinancialInformation =
  (vehicleId: string, branchId: string) => async (dispatch: Dispatch) => {
    if (requestCache.isPending(REQ_GET_DEFAULT_FINANCE_INFORMATION)) {
      return;
    }
    requestCache.isPending(REQ_GET_DEFAULT_FINANCE_INFORMATION, true);

    try {
      dispatch({ type: REQ_GET_DEFAULT_FINANCE_INFORMATION });

      const response = await http.json<FinancialInformation>(
        `/api/financial-information/${vehicleId}?branchId=${branchId}`,
        buildGetRequest(),
      );
      http.validateResponse(response);
      dispatch({
        type: RCV_GET_DEFAULT_FINANCE_INFORMATION,
        response: response.response,
      });
    } catch (_e) {
      dispatch({ type: REQUEST_FAILED, action: REQ_GET_DEFAULT_FINANCE_INFORMATION });
    }
    requestCache.isPending(REQ_GET_DEFAULT_FINANCE_INFORMATION, false);
  };

export const resetDefaultFinancialInformation = () => (dispatch: Dispatch) =>
  dispatch({ type: RESET_DEFAULT_FINANCE_INFORMATION });
